import React from 'react'
import { useGoogleLogin } from '@react-oauth/google'
import { Button } from '@/components/ui/button'
// Official "G" from Google's pre-approved sign-in assets (signin-assets.zip), unaltered.
import googleG from '@/assets/images/google/google-g.svg'
import useLogin from '@/services/api/auth/useLogin'
import { socialButtonClass, socialLogoClass } from './socialSignInStyles'

export default function GoogleLogin({
  setIsLoading,
  isLoading,
  onSuccess,
  label = 'Sign in with Google',
}: {
  setIsLoading: (isLoading: boolean) => void
  isLoading: boolean
  onSuccess: () => void
  /** Google-approved CTAs: "Sign in with Google" / "Sign up with Google". */
  label?: string
}) {
  const { login, loginStatus } = useLogin()
  const googleLogin = useGoogleLogin({
    onNonOAuthError: () => {
      setIsLoading(false)
    },
    onSuccess: (tokenResponse) => {
      login({
        platform: 'google',
        accessToken: tokenResponse.access_token,
      })
        .then(() => {
          onSuccess()
        })
        .finally(() => {
          setIsLoading(false)
        })
    },
    onError: () => {
      setIsLoading(false)
    },
  })
  return (
    <Button
      variant="outline"
      size="lg"
      className={socialButtonClass}
      loading={isLoading}
      onClick={() => {
        setIsLoading(true)
        googleLogin()
      }}
    >
      <img
        src={googleG}
        alt=""
        aria-hidden="true"
        className={socialLogoClass}
      />
      <span>{label}</span>
    </Button>
  )
}
